import "@/polyfills/promiseWithResolvers";
import './logger-init';
import "@/i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "@/index.css";
import "katex/dist/katex.min.css";
import App from "@/App";
import { registerServiceWorker } from "@/utils/registerServiceWorker";
import { initGA, initMixpanel, initProductAnalytics } from '@/analytics/analytics';
import { initSystemBarsThemeSync } from "@/utils/systemBars";
import { initChunkErrorRecovery } from "@/utils/chunkLoadHandler";

// Initialize global chunk recovery for seamless background updates
initChunkErrorRecovery();

// Initialize Native and Capacitor System Bars theme synchronization
try {
  initSystemBarsThemeSync();
} catch (e) {
  console.error('System bars theme sync error:', e);
}


// Set up axios interceptor to handle 401 errors globally
// Read env values from runtime-injected window.__ENV (preferred) or build-time process.env
const runtimeEnv = (typeof window !== 'undefined' && window.__ENV) || {};
const REACT_APP_GA_MEASUREMENT_ID = runtimeEnv.REACT_APP_GA_MEASUREMENT_ID || process.env.REACT_APP_GA_MEASUREMENT_ID;
const REACT_APP_MIXPANEL_TOKEN = runtimeEnv.REACT_APP_MIXPANEL_TOKEN || process.env.REACT_APP_MIXPANEL_TOKEN;

// Initialize Google Analytics / Mixpanel BEFORE rendering to ensure early events aren't lost
try {
  initProductAnalytics();
} catch (e) {
  console.error('Product Analytics Init Error:', e);
}

try {
  if (REACT_APP_GA_MEASUREMENT_ID) {
    initGA(REACT_APP_GA_MEASUREMENT_ID);
  }
} catch (e) {
  console.error('GA Init Error:', e);
}

try {
  if (REACT_APP_MIXPANEL_TOKEN) {
    initMixpanel(REACT_APP_MIXPANEL_TOKEN);
  }
} catch (e) {
  console.error('Mixpanel Init Error:', e);
}

// Path Rewrite Approach for Shared Links, Parent Promo Links, Affiliators, Signup & Login
// Intercept standard paths and convert them to HashRouter paths (for web/PWA)
const rawPath = (window.location.pathname || '').toLowerCase();
const isAffiliatorPath = rawPath.startsWith('/affiliator') || rawPath.startsWith('/affliator');

let isRedirecting = false;
if (isAffiliatorPath) {
    isRedirecting = true;
    const hash = (window.location.hash || '').toLowerCase();
    const search = window.location.search || '';
    let targetHash = '/affiliators';
    if (hash.includes('signup') || rawPath.includes('signup')) {
        targetHash = '/affiliators/signup';
    } else if (hash.includes('login') || rawPath.includes('login')) {
        targetHash = '/affiliators/login';
    }
    window.location.replace(`${window.location.origin}/#${targetHash}${search}`);
} else if (rawPath.startsWith('/affiliate') || rawPath.startsWith('/affliate')) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#${window.location.pathname}${window.location.search || ''}`);
} else if (window.location.pathname && (window.location.pathname === '/login' || window.location.pathname.startsWith('/login/'))) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#/login${window.location.search || ''}`);
} else if (window.location.pathname && (window.location.pathname === '/signup' || window.location.pathname.startsWith('/signup/'))) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#/signup${window.location.search || ''}`);
} else if (window.location.pathname && (window.location.pathname === '/book' || window.location.pathname.startsWith('/book/'))) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#${window.location.pathname}${window.location.search || ''}`);
} else if (window.location.pathname && (window.location.pathname.startsWith('/s/') || window.location.pathname.startsWith('/parent'))) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#${window.location.pathname}${window.location.search}`);
} else if (window.location.search && window.location.search.includes('token=')) {
    isRedirecting = true;
    window.location.replace(`${window.location.origin}/#/parent/plans${window.location.search}`);
}

if (!isRedirecting) {
  // Early persistence of referral coupon code from search params or hash params
  try {
    const urlSearch = window.location.search || '';
    const hash = window.location.hash || '';
    const hashSearch = hash.includes('?') ? hash.substring(hash.indexOf('?')) : '';
    const searchParams = new URLSearchParams(urlSearch || hashSearch);
    const couponFromUrl = searchParams.get('coupon');
    if (couponFromUrl && couponFromUrl.trim()) {
      localStorage.setItem('active_coupon_code', couponFromUrl.trim().toUpperCase());
    }
  } catch (_) {}

  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    // <React.StrictMode>
      <App />
    // </React.StrictMode>,
  );

  // Register service worker for offline capability
  // Only registers in production builds
  registerServiceWorker().catch((error) => {
    console.error("Failed to register service worker:", error);
  });
}
